import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export function Shell({
  children,
  centerLabel,
  rightLinks = true,
}: {
  children: ReactNode;
  centerLabel?: string;
  rightLinks?: boolean;
}) {
  return (
    <div className="min-h-screen flex flex-col">
      <header
        className="grid items-center sticky top-0 z-50 px-6 md:px-14 py-5 border-b backdrop-blur"
        style={{
          gridTemplateColumns: '1fr auto 1fr',
          background: 'rgba(240, 238, 233, 0.85)',
          borderColor: 'var(--rule)',
        }}
      >
        <Link to="/" className="no-underline" style={{ color: 'var(--ink)' }}>
          <span
            style={{
              fontSize: '22px',
              fontWeight: 500,
              letterSpacing: '-0.025em',
              lineHeight: 1,
            }}
          >
            we
            <span className="grad-text" style={{ padding: '0 0.04em', fontWeight: 400 }}>/</span>
            dpo
            <span style={{ marginLeft: 10, color: 'var(--muted-ink)', fontSize: 14 }}>· cmp</span>
          </span>
        </Link>
        <div className="meta hidden md:block text-center">{centerLabel ?? 'Cookie consent manager · v1'}</div>
        {rightLinks ? (
          <div className="justify-self-end flex gap-6 items-center">
            <Link className="meta hover:text-[var(--ink)] hidden sm:inline" to="/#how">
              How it works
            </Link>
            <Link className="meta hover:text-[var(--ink)] hidden sm:inline" to="/pricing">
              Pricing
            </Link>
            <span className="live-pill">Live</span>
          </div>
        ) : (
          <div />
        )}
      </header>
      <main className="flex-1">{children}</main>
      <footer
        className="px-6 md:px-14 py-10 flex flex-wrap justify-between items-center gap-4 border-t"
        style={{ borderColor: 'var(--rule)' }}
      >
        <span className="meta">© {new Date().getFullYear()} Entero Strategies Ltd. · we/dpo CMP</span>
        <span className="meta">
          <a href="https://wedpo.com/privacy-policy" className="hover:text-[var(--ink)]">
            Privacy Policy
          </a>
          {' · '}
          <a href="https://app.wedpo.com/license-agreement" className="hover:text-[var(--ink)]">
            License Agreement
          </a>
          {' · '}
          <a href="https://scanner.wedpo.com/refund-and-cancellation" className="hover:text-[var(--ink)]">
            Refund &amp; cancellation
          </a>
        </span>
      </footer>
    </div>
  );
}
